import { EmailResendPayload } from '../../../types/requests';
import { ConstructPost } from '../../types/ConstructPost';
import { AUTH_BASE_PATH } from '../constants/authenticationPath';

export const postResendVerifyEmail = (
  constructPost: ConstructPost,
  data: EmailResendPayload,
): Promise<unknown> =>
  constructPost(
    `${AUTH_BASE_PATH}/email/resend`,
    { data },
    { preventDefaultErrorToast: true },
  );
